<template>
  <section class="overflow myModal">    
    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'times']"/>
          </button>
          <h2>Selectionner vos destinataires</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->



    <!-- CONTENT -->
    <div class="block__messagerie content__messagerie content__messagerie-contact">
      <ion-searchbar @ionChange="eventSearch" :placeholder="general.searchPlaceholder" ></ion-searchbar>

      <!-- <Stack height="0.25rem"></Stack> -->
      <Stack></Stack>


      <h2 class="blue">Sélectionner vos destinataires</h2>

      <Stack></Stack>

      <div class="select__wrapper">
        <font-awesome-icon :icon="['far', 'chevron-down']" />
        <b-form-select  id="challenge-criteria"  v-model="selection"  :options="criteria" class="select" required>
        </b-form-select>
      </div>

      <Stack></Stack>

      <b-form-group>
        <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
          >
            Tous
          </b-form-checkbox>
          <Stack></Stack>
          <b-list-group>
            <b-list-group-item  v-for="commercial in filteredList" :key="commercial.id">
              <PuSkeleton>
              <b-form-checkbox
                  v-model="selected"
                  :id="commercial.id"
                  :name="commercial.fullname"
                  :value="commercial.fullname"      
                >
                  {{commercial.fullname}}
                  <div class="right" :class="commercial.class">
                    {{commercial.number}}
                  </div>
                </b-form-checkbox>
              </PuSkeleton>
            </b-list-group-item>
          </b-list-group>
                  
      </b-form-group>

      <footer v-if="selected.length">
        <div class="flex">
            <ul class="">
              <li v-for="(select,id) in selected" :key="id">
                 {{select}}
              </li>
            </ul>            
            
            <!-- </div> -->
            <button class="btn btn-blue" v-on:click="validated">Valider</button>

        </div>
      </footer>

    </div>
    <!-- CONTENT-->
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import utils from '../../../Utils'
import Stack from '../../../module/stack/Stack'

export default {
  name:"challengesMessageriesContact",
    components:{ 
      Stack,
    }, 
    props:{ 
      noTitle:Boolean,
    },
    computed: {
      ...mapGetters([
        'getBlog',
        'getLists',
        'getGeneral',
        'getCommercials',
      ]),
      filteredList() {
        return this.commercials.filter(commercial => {
          return commercial.fullname.toLowerCase().includes(this.search.toLowerCase())
      }) 
    } 
    },
    data () {
      return {
        form: {
          criteria: '',
        },  
        commercials: [],
        status: 'not_selected',
        content:"",
        general:"",
        lists:"",
        title:"",
        search: '',
        selected: [],
        selection:null,
        isLoading:true,
        isMobile:false,   
        criteria: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],          
      }
    },
    created (){
      this.commercials= this.getCommercials;
      this.content = this.getBlog;
      this.lists = this.getLists;
      this.general = this.getGeneral;
      this.isMobile = utils.isMobile();
      setTimeout(() => {
        this.isLoading = false;
      },2000);      
    },    
    methods : {
      eventSearch : function(event){
        this.search = event.target.value;
      },      
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challenges-messagerie"});  
      },    
      swipeRightHandler () {
          this.goBack();
      },  
      validated : function () {
        console.log(this.selected);
      }
    },
};
</script>
